import { CgInfo } from 'react-icons/cg';
import { Tooltip } from '@ds';
import { CommonRouteLegSchemaValues } from '@lp/features/RoutePlanner/components/RouteLegForm/validation';
import { useWatchFields } from '@/hooks/useWatchFields';
import { RouteLegTypeEnum } from '@/api/apis/route';
import { REPOSITION_SEGMENT_TYPES } from '@/utils/route';
import { TimeBuffersInfo } from './TimeBuffersInfo';

export const LegDetailsTitle = () => {
  const { segmentType, legType, formType } = useWatchFields<CommonRouteLegSchemaValues>([
    'segmentType',
    'legType',
    'formType',
  ] as const);

  const isCommercial = legType === RouteLegTypeEnum.CommercialFlightAviaLeg;
  const isReposition = REPOSITION_SEGMENT_TYPES.includes(segmentType);

  return (
    <div className="flex justify-between items-center">
      <h1 className="text-l-sb text-base-5">Leg details</h1>
      <div className="flex flex-row items-center gap-2">
        <p className="text-sm text-base-5">
          {isCommercial ? 'Local time is used' : 'Local time is used. Time buffers added'}
        </p>
        {!isCommercial && (
          <Tooltip
            className="text-sm text-base-5"
            placement="top"
            showArrow
            content={<TimeBuffersInfo type={formType} isReposition={isReposition} />}
          >
            <div>
              <CgInfo size={14} />
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
